import { Box, Grid2 as Grid, InputAdornment } from "@mui/material";
import { useWatch } from "react-hook-form";
import { TextField } from "../../../common";
import { CREW_OVERTIME_MULTIPLIER } from "../../../../constants";
import { ModalForm, PayRate, PayRateFormData } from "../../../../types";
import { UserModel } from "../../../../models";
import { payRateFormSchema } from "../../../../validations";
import { useValidateForm } from "../../../../hooks";

const currencyAdornment = {
  input: {
    startAdornment: <InputAdornment position="start">$</InputAdornment>,
  },
};

type PayRateFormProps = ModalForm<PayRate, PayRateFormData>;

export const PayRateForm = ({
  id,
  defaultValues,
  handleEdit,
}: PayRateFormProps) => {
  const { register, control, handleSubmit, errors } =
    useValidateForm<PayRateFormData>(payRateFormSchema);
  const baseRate = useWatch({
    control,
    name: "baseRate",
    defaultValue: defaultValues?.baseRate ?? NaN,
  });
  const overtimeRate = UserModel.getCrewOvertimeRate(baseRate);

  return (
    <Box
      onSubmit={handleSubmit(handleEdit)}
      component={"form"}
      id={id}
      noValidate
      sx={{ py: 2 }}
    >
      <Grid container columnSpacing={2} rowSpacing={3}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            type="number"
            label="Base Rate / hr"
            name="baseRate"
            register={register}
            valueAsNumber
            error={errors["baseRate"]}
            defaultValue={defaultValues?.baseRate ?? undefined}
            required
            slotProps={currencyAdornment}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            type="number"
            label={`Overtime Rate / hr (${CREW_OVERTIME_MULTIPLIER}× base, preview)`}
            name="overtimeRate"
            value={overtimeRate ?? ""}
            disabled
            slotProps={currencyAdornment}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
